import { ReactElement } from 'react';
import { Navigate } from 'react-router';
import { useSelector } from 'react-redux';

import { Features } from '@gymcloud/core';

import { getFeatures } from 'web-selectors';

const mapState = state => ({
  features: getFeatures(state),
});

type FeatureKeyOrKeysArray = keyof Features | Array<keyof Features>;
interface Props {
  allowedFeatures: FeatureKeyOrKeysArray;
  children: ReactElement<any>;
}

const ProtectedRoute = ({ allowedFeatures, children }: Props) => {
  const { features } = useSelector(mapState);

  const single = typeof allowedFeatures === 'string'
    && features[allowedFeatures];
  const multiple = Array.isArray(allowedFeatures)
    && allowedFeatures.every(key => features[key]);

  if (single || multiple) return children;

  return <Navigate to="/welcome" />;
};

export default ProtectedRoute;
